document.addEventListener("DOMContentLoaded", function () {
    let searchInput = document.getElementById("product-search");
    let products = document.querySelectorAll(".shop__grid-item"); 

  if(!searchInput){
    return;
  }

    searchInput.addEventListener("keyup", function () {
        let filter = searchInput.value.toLowerCase();

        products.forEach(product => {
            let title = product.querySelector(".product-card__title").innerText.toLowerCase();
            if (title.includes(filter)) {
                product.style.display = "block"; 
            } else {
                product.style.display = "none";
            }
        });
    });
});
